import styled, { css, keyframes } from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { HEADER_HEIGHT } from '@yme/common/constants';
import { MAX_HEIGHT_MENU } from '@yme/components/Header/constants';
import { colorBrandYamahaRed, colorCoreBackground1000, colorCoreBlack900Base, colorCoreGray500, colorCoreWhite1000, colorWhiteTransparent000000, } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { letterSpacingXS } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
const leftShadow = css `
  &::before {
    left: 0;
    background-image: linear-gradient(
      to right,
      ${colorCoreWhite1000} 25%,
      ${colorWhiteTransparent000000} 100%
    );
    opacity: 1;
  }
`;
const rightShadow = css `
  &::after {
    right: 0;
    background-image: linear-gradient(
      to left,
      ${colorCoreWhite1000} 25%,
      ${colorWhiteTransparent000000} 100%
    );
    opacity: 1;
  }
`;
const slideDown = keyframes `
  from {
    transform: translateY(-100%);
  }

  to {
    transform: translateY(0%);
  }
`;
const getShadow = (isLeftVisible = true, isRightVisible = true, isRightToLeft) => {
    const firstShadow = isRightToLeft ? rightShadow : leftShadow;
    const lastShadow = isRightToLeft ? leftShadow : rightShadow;
    const bothShadow = isRightToLeft
        ? css `
        ${rightShadow} ${leftShadow}
      `
        : css `
        ${leftShadow} ${rightShadow}
      `;
    if (!isLeftVisible && !isRightVisible) {
        return bothShadow;
    }
    if (!isLeftVisible) {
        return firstShadow;
    }
    if (!isRightVisible) {
        return lastShadow;
    }
    return '';
};
export const MenuContainerStyled = styled.div `
  position: relative;
  width: 100%;
  overflow: hidden;

  margin: 0 ${INDENT.xs};

  ${ADAPTIVE.maxWidth.desktop} {
    margin: 0 ${INDENT.sm};
  }
`;
export const NavStyled = styled.nav `
  overflow-y: hidden;
  overflow-x: scroll;
  user-select: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
export const MenuListStyled = styled.ul `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0;
  padding: 7px 0;
  list-style: none;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    display: block;
    height: 100%;
    width: 40px;
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;
  }

  ${({ isFirstOnScreen, isLastOnScreen, isRightToLeft }) => getShadow(isFirstOnScreen, isLastOnScreen, isRightToLeft)};
`;
export const MenuItemStyled = styled.li `
  white-space: nowrap;
  color: ${colorCoreBlack900Base};

  ${({ isActive }) => isActive && `color: ${colorBrandYamahaRed}`};

  &:not(:last-child) {
    ${({ isRightToLeft }) => isRightToLeft ? `margin-left: ${INDENT.xs}` : `margin-right: ${INDENT.xs}`};
  }
`;
export const MenuLinkStyled = styled(Button) `
  height: auto;
  padding: 0;
  border-radius: 0;
  transition: 0.3s;
  color: currentColor;

  ${getTextStyles('Play', 700, 14, 16)}

  ${letterSpacingXS}
  
  &:hover,
  &:active {
    text-decoration: underline;
    color: currentColor;
  }
`;
export const NestedContainerStyled = styled.section `
  position: absolute;
  top: 100%;
  left: 0;
  z-index: ${Z_INDEX.level9};
  width: 100%;
  background-color: ${colorCoreBackground1000};
  animation: ${slideDown} 0.2s ease-out;

  max-height: ${MAX_HEIGHT_MENU};
  border-top: 1px solid ${colorCoreGray500};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl'};

  @media only screen and (max-height: ${MAX_HEIGHT_MENU}) {
    max-height: calc(100vh - (${HEADER_HEIGHT.lg} + ${INDENT.l}));
  }
`;
